module.exports = __webpack_public_path__ + "static/zh-Hant-7578ffe853bf8d912967af3d45ee571f.svg";